import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconShip$1 = /*@__PURE__*/ proxyCustomElement(class WppIconShip extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-ship", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.75 2.75C6.75 2.33579 7.08579 2 7.5 2H12.5C12.9142 2 13.25 2.33579 13.25 2.75V4.25H15C15.4142 4.25 15.75 4.58579 15.75 5V8.90798L16.7692 9.29999C16.9666 9.37591 17.1228 9.53163 17.1992 9.7288C17.2757 9.92597 17.2654 10.1463 17.1708 10.3354L15.5867 13.5036C15.3617 13.4286 15.1513 13.4033 15 13.4033C14.6836 13.4033 14.1085 13.514 13.6826 13.9578L15.4597 10.4035L10.4487 8.47615C10.1599 8.36506 9.84011 8.36506 9.55128 8.47615L4.54026 10.4035L6.31744 13.9578C5.89148 13.514 5.3164 13.4033 5 13.4033C4.8487 13.4033 4.63826 13.4286 4.41326 13.5036L2.82918 10.3354C2.7346 10.1463 2.72428 9.92597 2.80075 9.7288C2.87722 9.53163 3.03338 9.37591 3.23077 9.29999L4.25 8.90798V5C4.25 4.58579 4.58579 4.25 5 4.25H6.75V2.75ZM8.25 4.25H11.75V3.5H8.25V4.25ZM5.75 8.33105L9.01281 7.07613C9.64825 6.83173 10.3518 6.83173 10.9872 7.07613L14.25 8.33105V5.75H5.75V8.33105Z", fill: "currentColor" }), h("path", { d: "M15 14.4033C15.0383 14.4033 15.0829 14.4067 15.1311 14.4149C15.3475 14.4514 15.6373 14.5833 15.7652 14.9312C15.9272 15.3718 16.3885 16.25 17.5 16.25C17.9142 16.25 18.25 16.5858 18.25 17C18.25 17.4142 17.9142 17.75 17.5 17.75C16.2758 17.75 15.4876 17.1724 15 16.5757C14.5124 17.1724 13.7242 17.75 12.5 17.75C11.2758 17.75 10.4876 17.1724 10 16.5757C9.5124 17.1724 8.72422 17.75 7.5 17.75C6.27578 17.75 5.48761 17.1724 5 16.5757C4.51239 17.1724 3.72422 17.75 2.5 17.75C2.08579 17.75 1.75 17.4142 1.75 17C1.75 16.5858 2.08579 16.25 2.5 16.25C3.61149 16.25 4.07279 15.3718 4.23476 14.9312C4.36266 14.5833 4.65248 14.4514 4.8689 14.4149C4.91711 14.4067 4.96168 14.4033 5 14.4033C5.21037 14.4033 5.60885 14.5058 5.76524 14.9312C5.84201 15.14 5.98601 15.4471 6.2346 15.7125C6.51052 16.007 6.91529 16.25 7.5 16.25C8.61149 16.25 9.07279 15.3718 9.23476 14.9312C9.39115 14.5058 9.78963 14.4033 10 14.4033C10.2104 14.4033 10.6089 14.5058 10.7652 14.9312C10.9272 15.3718 11.3885 16.25 12.5 16.25C13.0847 16.25 13.4895 16.007 13.7654 15.7125C14.014 15.4471 14.158 15.14 14.2348 14.9312C14.3911 14.5058 14.7896 14.4033 15 14.4033Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-ship-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-ship", "wpp-icon-ship-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-ship-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-ship-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconShip$1);
      }
      break;
  } });
}

const WppIconShip = WppIconShip$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconShip, defineCustomElement };
